<template>
  <section class="result">
    <div class="wrap">
      <h2>Resultat av jämförelse</h2>
      <div class="contain-rows">
        <div class="row">
          <div class="first-entry"></div>
          <template v-for="(company, index) in companies" v-if="chosen.includes(company.name)">
            <div class="space" v-if="index !== companies.length"></div>
            <div class="column">
              <div class="images">
                <img :src="company.logotype" />
              </div>
            </div>
          </template>
        </div>
        <div class="row">
          <div class="first-entry">
            <div class="highest">
              {{ highestPrice | normalize }} kr/liter
            </div>
            <div class="lowest">
              {{ lowestPrice | normalize }} kr/liter
            </div>
          </div>

          <template v-for="(company, index) in companies" v-if="chosen.includes(company.name)">
            <div class="space">
              <div v-for="n in 5" class="space-line"></div>
            </div>
            <div class="column">
              <div class="chart-column-container">
                <div class="chart-fill" v-scroll="{ name: company.name }" :style="{ background: company.name !== 'Tanka' ? '#75a3b1' : '' }" :id="company.name">
                  <div class="text">
                    {{ lowValue }}
                  </div>
                </div>
              </div>
            </div>
          </template>

        </div>
        <div class="button-row" v-if="target">
          <div class="button" v-on:click="scrollDown">Årlig besparing</div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  import velocity from 'velocity-animate'
  import scrollMonitor from 'scrollmonitor'
  import sizzle from 'sizzle'
  import scrollDown from 'lib/scrollDown'
  import Odometer from 'odometer'
  import wNumb from 'wnumb'

  export default {
    props: {
      companies: {
        type: Array
      },
      type: String,
      chosen: Array
    },
    data () {
      return {
        highValue: 0.00,
        lowValue: 0.00,
        target: null
      }
    },
    filters: {
      normalize (value) {
        const formatter = wNumb({
          mark: ',',
          thousand: ' '
        })
        return formatter.to(value)
      }
    },
    mounted () {
      scrollMonitor.recalculateLocations()
      this.target = sizzle('.savings')[0]
    },
    methods: {
      scrollDown () {
        scrollDown(this.target.offsetTop)
      },
      // Calculation to see how many pixels the chart needs in height
      calculate (value) {
        const height = sizzle('.chart-column-container', this.$el)[0].clientHeight
        const pxPerCent = height / ((this.highValue - this.lowValue) * 100)
        return parseInt((value - this.lowValue) * 100 * pxPerCent)
      },
      increaseHeight (element, watcher, value, odElement) {
        const that = this
        velocity(element, {
          height: that.calculate(value)
        }, {
          duration: 1500,
          begin () {
            odElement.update(value + 100 + 0.001)
          },
          progress (element, complete, remaining, start, tweenValue) {},
          complete () {
            watcher.recalculateLocation()
          }
        })
      },
      resetHeight (element, watcher, odElement) {
        velocity(element, {
          height: 20
        }, {
          complete: () => {
            odElement.update(this.lowValue)
            watcher.recalculateLocation()
          }
        })
      }
    },
    directives: {
      scroll: {
        inserted (el, binding, vnode) {
          // Bind vue instance to that constant
          const that = vnode.context
          // Create a watcher with scrollMonitor library
          const watcher = scrollMonitor.create(el)

          const od = new Odometer({
            el: el.firstChild,
            format: '( ddd),ddd',
            duration: 1000
          })

          // Function when it enters viewport
          watcher.enterViewport(() => {
            if (el.offsetParent === null) {
              return
            }

            const company = that.companies.find((x) => {
              return x.name === el.getAttribute('id')
            })

            const type = that.type

            if (type === 'dieselPrice') {
              if (company.name === 'Tanka') {
                that.increaseHeight(el, watcher, company.data.dieselPrice + company.data.cardDiscount + company.data.invoiceDiscount, od)
              } else {
                that.increaseHeight(el, watcher, company.data.dieselPriceList + company.data.cardDiscount + company.data.invoiceDiscount, od)
              }
            } else {
              if (company.name === 'Tanka') {
                that.increaseHeight(el, watcher, company.data.gasPrice + company.data.cardDiscount + company.data.invoiceDiscount, od)
              } else {
                that.increaseHeight(el, watcher, company.data.gasPriceList + company.data.cardDiscount + company.data.invoiceDiscount, od)
              }
            }
          })

          // When it exists viewport
          watcher.exitViewport(() => {
            that.resetHeight(el, watcher, od)
          })
        }
      }
    },
    computed: {
      highestPrice () {
        const that = this
        if (this.companies.length === 0) {
          return that.highValue
        }

        that.highValue = 0.00

        this.companies.forEach((x) => {
          if (x.data[that.type] > that.highValue) {
            that.highValue = window.Math.ceil(x.data[that.type])
          }
        })

        return that.highValue
      },
      lowestPrice () {
        const that = this
        if (this.companies.length === 0) {
          return that.lowValue
        }

        that.lowValue = 0.00

        this.companies.forEach((x) => {
          const totValue = x.data[that.type] + x.data.cardDiscount + x.data.invoiceDiscount
          if ((totValue < that.lowValue || that.lowValue === 0.00) && x.data[that.type] !== 0) {
            that.lowValue = window.Math.floor(totValue)
          }
        })

        return that.lowValue
      }
    }
  }
</script>

<style rel="stylesheet/scss" type="text/css" lang="scss">
  .chart-fill {
    .odometer .odometer-inside .odometer-digit:first-child,
    .odometer .odometer-inside .odometer-formatting-mark:nth-child(2),
    .odometer .odometer-inside .odometer-digit:last-child {
      display: none
    }
  }
</style>

<style rel="stylesheet/scss" type="text/css" lang="scss" scoped>
  @import "~styles/button.scss";

  section {
    background: #488091;
    width: 100%;
    height: 550px;
    overflow: hidden;
    text-align: center;
    padding-bottom: 20px;

    .wrap {
      display: inline-block;
      max-width: 850px;
      height: 100%;
      width: 100%;
      padding: 0 20px;
      text-align: left;

      .contain-rows {
        overflow: hidden;
        display: inline-block;
        height: calc(100% - 80px);

        @media screen and (max-width: 800px) {
          width: calc(100% - 40px);
        }
      }
    }

    h2 {
      color: #fff;
      text-align: left;
      font-size: 2.1em;
      letter-spacing: 0.05em;
      margin-top: 20px;
      margin-bottom: 20px;

      @media screen and (max-width: 800px) {
        font-size: 1.5em;
      }
    }

    .row {
      overflow: hidden;

      &:first-child {
        margin-bottom: 15px;
      }

      &:nth-child(2) {
        height: 36px;
        margin-bottom: 20px;

        .column {
          width: 92px;
        }

        .space {
          width: 32px;
        }
      }

      &:nth-child(2) {
        height: 70%;

        @media screen and (max-height: 700px) {
          height: 65%;
        }
        @media screen and (max-height: 600px) {
          height: 60%;
        }

        .column {
          height: calc(100% - 4px);
          border: 2px solid #fff;
          border-top-width: 1px;
          border-bottom-width: 3px;
        }

        .space {
          border-top: 1px solid #fff;
          border-bottom: 3px solid #fff;
          height: calc(100% - 4px);
        }
      }

      .first-entry, .column, .space {
        float: left;
        color: #fff;
      }

      .first-entry {
        min-height: 20px;
        font-size: 1.5em;
        height: 100%;
        width: 150px;
        position: relative;
        overflow: hidden;

        @media screen and (max-width: 800px) {
          width: 100px;
          font-size: 1em;
        }

        .highest, .lowest {
          position: absolute;
        }

        .lowest {
          bottom: 0;
        }
      }

      .column {
        width: 96px;
        text-align: center;

        .images {
          height: 36px;

          img {
            vertical-align: middle;
            display: inline;
            max-width: 100%;
            max-height: 100%;
          }
        }

        .chart-column-container {
          background: #fff;
          float: left;
          height: 100%;
          width: 100%;
          display: inline-block;
          position: relative;

          .chart-fill {
            width: 100%;
            min-height: 20px;
            background: #178394;
            position: absolute;
            bottom: 0;

            .text {
              font-size: 1.5em;
            }
          }
        }
      }

      .space {
        float: left;
        width: 32px;
        height: 10px;

        &:nth-child(2) {
          display: none;
        }

        .space-line {
          width: 100%;
          height: 99px;
          border-bottom: 1px solid #fff;

          &:last-child {
            border: none;
          }
        }
      }

      .hidden {
        display: none;
      }
    }

    .button-row {
      width: calc(100% - 150px);
      margin-left: 150px;

      @media screen and (max-width: 800px) {
        margin-left: 0;
        width: 100%;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// result.vue?d25f47d0